import React, { useState, useEffect } from 'react';
import './Features.css';
import feat1 from "../Assets/feat/feat1.jpg"
import feat2 from "../Assets/feat/feat2.avif"
import feat3 from "../Assets/feat/feat3.avif"

const Features = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  const features = [
    // {
    //   id: 1,
    //   title: 'Premium Fleet',
    //   description: 'Choose from our collection of luxury and economy vehicles, all maintained to the highest standards for your comfort and safety.',
    //   image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTKWoq_eHN06CZw90DKsh7ohejiOHhc622QbQ&s'
    // },
    {
      id: 2,
      title: '24/7 Support',
      description: 'Our dedicated customer support team is available round the clock to assist you with any queries or emergencies.',
      image: feat1
    },
    {
      id: 3,
      title: 'Easy Booking',
      description: 'Book your perfect vehicle in just a few clicks with our intuitive online booking system and mobile app.',
      image: feat2
    },
    {
      id: 4,
      title: 'Best Prices',
      description: 'Enjoy competitive rates with complete price transparency. No hidden charges, just honest pricing for premium service.',
      image: feat3
    }
  ];

  return (
    <section className="features-section">
      <div className="features-container">
        <div className={`features-header ${isVisible ? 'animate-fade-in' : ''}`}>
          <span className="features-badge">Why Choose Us</span>
          <h2 className="features-title">Experience Excellence in Every Journey</h2>
          <p className="features-subtitle">
            Discover what makes us the preferred choice for thousands of satisfied customers worldwide
          </p>
        </div>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div 
              key={feature.id} 
              className={`feature-card ${isVisible ? 'animate-slide-up' : ''}`}
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <div className="feature-image-container">
                <img 
                  src={feature.image} 
                  alt={feature.title}
                  className="feature-image"
                />
                <div className="feature-overlay"></div>
              </div>
              <div className="feature-content">
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
                <div className="feature-link">
                  <span>Learn More</span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M7 17L17 7M17 7H7M17 7V17"/>
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;